module.exports = __webpack_public_path__ + "static/img/xint.2e377ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/data/xint.jpg
// module id = fAnM
// module chunks = 0